// extracted by mini-css-extract-plugin
export default {"container":"Courses_container__n2GJo","backUpTop":"Courses_backUpTop__ddhnf","link":"Courses_link__KDNvm","icon":"Courses_icon__NM7r8"};